<template>
  <el-dialog
    :title="type == 'add' ? '新增' : '编辑'"
    :visible.sync="dialogFormVisible"
    :close-on-click-modal="false"
    class="addModal"
    width="600px"
  >
    <el-form :model="modelForm" ref="formRef" :rules="rules" label-width="auto">
      <el-form-item label="试卷名称：" prop="name" class="model-input">
        <el-input
          maxlength="30"
          v-model="modelForm.name"
          placeholder="请输入试卷名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="试卷等级：" prop="courseLevel" class="model-input">
        <el-select
          v-model="modelForm.courseLevel"
          placeholder="请选择试卷等级"
          style="width: 100%;"
        >
          <el-option
            v-for="item in examLevel"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel">关闭</el-button>
      <el-button
        type="primary"
        @click="submitFunc"
        :disabled="submitLoading"
        v-loading="submitLoading"
        >提交</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { addPaper, editPaper } from "@/api/manage";
import { examLevel } from "@/utils/dict.js";
import { debounce } from "lodash";
export default {
  data() {
    return {
      examLevel,
      dialogFormVisible: false,
      type: "",
      modelForm: {
        name: ""
      },
      submitLoading: false,
      rules: {
        name: [{ required: true, message: "请输入试卷名称", trigger: "blur" }],
        courseLevel: [
          { required: true, message: "请选择试卷等级", trigger: "blur" }
        ]
      },
      submitFunc: null
    };
  },
  methods: {
    open(type, row = {}) {
      this.type = type;
      this.dialogFormVisible = true;
      if (this.$refs.formRef) this.$refs.formRef.resetFields();
      this.modelForm = { ...row, ...{ score: 0 } };
    },
    cancel() {
      this.dialogFormVisible = false;
    },
    async submitForm() {
      if (this.submitLoading) return;
      this.submitLoading = true;
      try {
        const valid = await this.$refs.formRef.validate();
        if (!valid) {
          return false;
        }
        if (this.type == "add") {
          await addPaper(this.modelForm);
        } else {
          await editPaper(this.modelForm);
        }
        this.cancel();
        this.$emit("success", this.modelForm);
      } finally {
        this.submitLoading = false;
      }
    }
  },
  created() {
    this.submitFunc = debounce(this.submitForm, 300, {
      leading: true,
      trailing: false
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Paper/Theory/PaperDialog.vue